import { minsToMills } from "../utils/utils";

const AWAY_RELOAD_THRESHOLD_MS = minsToMills(15);

// A page restored from the back/forward cache resumes with the exact JS and DOM it was frozen with. That's instant
// and harmless for a quick trip, but after a long absence it can be an old build or hold stale session state, and
// nothing on a restored page re-runs the startup logic. pageshow's `persisted` flag is the only signal that a restore
// happened, so time the absence from pagehide and reload once it's long enough to matter. A reload is a fresh load
// (persisted is false), so this can't loop.
export default {
    init(){
        let hiddenAt: number | undefined;

        window.addEventListener('pagehide', () => {
            hiddenAt = Date.now();
        });

        window.addEventListener('pageshow', e => {
            if(!e.persisted) return;

            if(hiddenAt && Date.now() - hiddenAt >= AWAY_RELOAD_THRESHOLD_MS) location.reload();
        });
    },
}
